import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, Form, Input, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import { ValidUrl } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useIsSiteRequired } from "@/mobile/Settings/Business/Edit/utils/useIsSiteRequired";
import { useIsSiteDisabled } from "@/mobile/Settings/Business/Edit/utils/useIsSiteDisabled";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessWebsite: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const siteApi = useAppSelector((state) => state.user.businessInfo?.site);
  const isSiteRequired = useIsSiteRequired();
  const isSiteDisabled = useIsSiteDisabled();
  const [site, setSite] = useState<string | undefined>();

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.websiteAddress")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <Form
            onFinish={() =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.taxCode.url,
                fieldName: "site",
                fieldValue: site,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ site: mobileFormEditState.site ?? siteApi }}
          >
            <Form.Item
              label={t("settings.business.websiteAddress")}
              rules={[
                { required: isSiteRequired },
                {
                  validator(_rule: any, value: any): Promise<void> {
                    // eslint-disable-next-line no-nested-ternary
                    return value && !ValidUrl(value)
                      ? value.includes("http")
                        ? Promise.reject(t("error.url"))
                        : Promise.reject(t("error.http"))
                      : Promise.resolve();
                  },
                },
              ]}
              name={"site"}
            >
              <Input
                value={site}
                onChange={(event: any) => setSite(event.target.value)}
                placeholder={t("settings.business.websiteAddress")}
                disabled={isSiteDisabled}
              />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.websiteAddress1")}</Typography.Text>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.websiteAddress2")}</Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessWebsite;
